import Immutable from 'immutable';
import { isBetradarWidgetAvailable } from 'nike-ui/src/components/match-statistics/utils';
import { isRadarStream, isVideoStream } from 'nike-ui/src/components/turboLive/push/overview/handlers';

export const trackingPropsForSportEvent = sportEvent => {
    if (!sportEvent) {
        return;
    }

    let mt_type;
    const sport = sportEvent.get('sportName');
    const tournament = sportEvent.get('tournamentName');
    const participants = (
        Immutable.fromJS(sportEvent.get('participants')) ||
        [sportEvent.getIn(['opponents', 'home']), sportEvent.getIn(['opponents', 'away'])].filter(Boolean)
    ).join(' - ');
    const matchId = sportEvent.get('id') || sportEvent.get('sportEventId');
    const hasStream = isVideoStream(sportEvent);

    if (isRadarStream(sportEvent)) {
        if (isBetradarWidgetAvailable(sportEvent)) {
            mt_type = 'BR';
        } else {
            mt_type = 'MT';
        }
    }
    return {
        'data-mt-type': mt_type,
        'data-sport': sport,
        'data-tournament': tournament,
        'data-participants': participants,
        'data-match-id': matchId,
        'data-stream': hasStream
    };
};
